export default __webpack_public_path__ + "static/media/Curio of the Archaeologian.ceaad507.jpg";